var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAv5SpecialAttentionDisease = function SvgAv5SpecialAttentionDisease(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-variant": "icon-with-background",
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "background",
    d: "M7.207 2.064.655 14.987c-.3.591.13 1.29.792 1.29h13.106c.663 0 1.092-.699.792-1.29L8.793 2.064a.889.889 0 0 0-1.586 0Z",
    fill: "#002774"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "inner-vectors"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 7v4",
    stroke: "#fff",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 14,
    r: 1,
    fill: "#fff"
  }))));
};
export { SvgAv5SpecialAttentionDisease as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyBkYXRhLXZhcmlhbnQ9Imljb24td2l0aC1iYWNrZ3JvdW5kIiB2aWV3Qm94PSIwIDAgMTYgMTciIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICA8cGF0aCBjbGFzcz0iYmFja2dyb3VuZCIgZD0iTTcuMjA3MiAyLjA2MzU4TDAuNjU0NTI3IDE0Ljk4NjlDMC4zNTQ3MTIgMTUuNTc4MiAwLjc4NDM2IDE2LjI3NzggMS40NDczMyAxNi4yNzc4SDE0LjU1MjdDMTUuMjE1NiAxNi4yNzc4IDE1LjY0NTMgMTUuNTc4MiAxNS4zNDU1IDE0Ljk4NjlMOC43OTI4IDIuMDYzNThDOC40NjM2MiAxLjQxNDM3IDcuNTM2MzggMS40MTQzNyA3LjIwNzIgMi4wNjM1OFoiIGZpbGw9IiMwMDI3NzQiLz4KICAgIDxnIGNsYXNzPSJpbm5lci12ZWN0b3JzIj4KICAgICAgICA8cGF0aCBkPSJNOCA3TDggMTEiIHN0cm9rZT0id2hpdGUiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIi8+CiAgICAgICAgPGNpcmNsZSBjeD0iOCIgY3k9IjE0IiByPSIxIiBmaWxsPSJ3aGl0ZSIvPgogICAgPC9nPgo8L3N2Zz4=";